import Toggle, { ToggleProps } from './Toggle'
export { Toggle, ToggleProps }
export default Toggle
